import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Card, Stack, Link, Alert, Tooltip, Container, Typography, Button, Grid, useMediaQuery, useTheme, IconButton } from '@material-ui/core';
// routes
import { PATH_AUTH } from '../../routes/paths';
// hooks
import useAuth from '../../hooks/useAuth';
// layouts
import AuthLayout from '../../layouts/AuthLayout';
// components
import Page from '../../components/Page';
import { MHidden } from '../../components/@material-extend';
import { LoginForm } from '../../components/authentication/login';
import AuthFirebaseSocials from '../../components/authentication/AuthFirebaseSocial';
import LogoImg from '../../images/Loader_Logo.png'
import BgHome from '../../images/home-image.png'
import SplashScreen from 'src/components/settings/MayuraMobileSplashScreen';
import AnnouncementBanner from 'src/components/AnnouncementBanner';
import { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import arrowBackOutline from '@iconify/icons-eva/arrow-back-outline';
// ----------------------------------------------------------------------

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  height: '100%',
  position: 'relative',
  // maxWidth: 604,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(5)
  // margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  minWidth: 600,
  display: 'flex',
  height: 'fit-content',
  flexDirection: 'column',
  alignContent: 'center',
  justifyContent: 'center',
  boxShadow: '0px 16px 32px -4px rgba(145, 158, 171, 0.24), 0px 0px 2px 0px rgba(145, 158, 171, 0.24)',
  backgroundColor: 'rgba(50, 50, 50, 0.95)',
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1.5),
  [theme.breakpoints.down('sm')]: {
    minWidth: '100%',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    padding: theme.spacing(0.5),
  }
}));

// ----------------------------------------------------------------------

export default function Login() {
  const navigate = useNavigate();
  const { method, login, isAuthenticated } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [showSplash, setShowSplash] = useState(() => !sessionStorage.getItem('splashShown'));

  useEffect(() => {
    if (showSplash) {
      const timer = setTimeout(() => {
        setShowSplash(false);
        sessionStorage.setItem('splashShown', 'true');
      }, 2000); // Optional delay
      return () => clearTimeout(timer);
    }
  }, [showSplash]);


  const handleLoginAuth0 = async () => {
    try {
      await login();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {isMobile && showSplash && !isAuthenticated && <SplashScreen />}
      <Grid container direction='row'>
        <MHidden width="lgDown">
          <Grid item xs={12} md={4} sx={{ p: 2 }}>
            <SectionStyle>
              <Box sx={{ position: 'absolute', top: 24, left: 24 }}>
                <IconButton 
                  onClick={() => navigate('/')} 
                  sx={{ 
                    bgcolor: 'rgba(145, 158, 171, 0.08)', 
                    '&:hover': { bgcolor: 'rgba(145, 158, 171, 0.16)' } 
                  }}
                >
                  <Icon icon={arrowBackOutline} width={24} height={24} />
                </IconButton>
              </Box>
              <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 1 }}>
                Hi, Welcome To <br />
                Mayura Logistics
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ px: 5, mb: 5 }}>
                Official portal of MAYURA VAHANAM
              </Typography>
              <img src={"/static/illustrations/illustration_login.png"} alt="login" />
            </SectionStyle>
          </Grid>
        </MHidden>
        <Grid item xs={12} md={12} lg={8} sx={{ backgroundImage: { xs: 'none', sm: `url(${BgHome})` }, backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: '100vh', alignContent: 'center', alignItems: 'center', p: { xs: 2, md: 2, lg: 0 }, textAlign: { xs: 'center', sm: 'left' } }}>
          {/* <AnnouncementBanner variant="login" width="50%" /> */}
          <ContentStyle>
            {/* <AnnouncementBanner variant="login" /> */}
            <Box sx={{ display: { xs: 'flex', sm: 'none' }, justifyContent: 'center', alignItems: 'center', p: 1 }}>
              <Box component="img" src={LogoImg} sx={{ width: 90, height: 90, borderRadius: '50%', border: '2px solid', borderColor: '#e6e6e6' }} />
            </Box>
            <Stack direction="row" alignItems="center" sx={{ mb: { xs: 3, sm: 5 }, mt: { xs: 2, sm: 0 } }}>
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="h4" color={'primary.main'} gutterBottom>
                  Sign in to Mayura Logistics
                </Typography>
                <Typography variant="body2" sx={{ color: 'secondary.light', fontSize: '0.8rem', mt: { xs: -1, sm: 0 } }}>
                  Operated by MAYURA VAHANAM
                </Typography>
                <Typography sx={{ color: 'secondary.light', mt: 0.5 }}>Enter your details below.</Typography>
              </Box>

              <Box component="img" src={LogoImg} sx={{ width: 60, height: 60, display: { xs: 'none', sm: 'flex' } }} />
            </Stack>

            {method === 'firebase' && <AuthFirebaseSocials />}

            {method !== 'auth0' ? (
              <LoginForm />
            ) : (
              <Button fullWidth size="large" type="submit" variant="contained" onClick={handleLoginAuth0}>
                Login
              </Button>
            )}
            <Typography variant="body2" sx={{ color: '#fff', mt: 2, textAlign: 'center' }}>
              © MAYURA VAHANAM. All rights reserved.
            </Typography>
          </ContentStyle>
        </Grid>
      </Grid>
    </>
  );
}
